module.exports = __webpack_public_path__ + "img/2.0853cd9e.png";